import {
  Box,
  Button,
  Chip,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import moment from 'moment/moment'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import AddIcon from '@mui/icons-material/Add'
import { unlinkZendeskTicket } from '../../Apis/routes/zendesk'
import { getStatusDisplayInfo } from '../utils/zendesk.utils'

export const LinkedZendeskTicketsTable = ({
  ticketId,
  navigateToSearchView,
  zendeskTickets,
  setZendeskTickets,
  type,
}) => {
  const handleUnlinkZendeskTicket = async (zendeskTicketId) => {
    await unlinkZendeskTicket(ticketId, zendeskTicketId, type)

    setZendeskTickets((prevState) =>
      prevState.filter((zendeskTicket) => zendeskTicket.id !== zendeskTicketId)
    )
  }

  return (
    <>
      {zendeskTickets.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">ID</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Canal</TableCell>
                <TableCell align="left">Demandeur</TableCell>
                <TableCell align="left">Sujet</TableCell>
                <TableCell align="left">Assigné</TableCell>
                <TableCell align="left">Crée le</TableCell>
                <TableCell align="left">Mise à jour</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {zendeskTickets.map((zendeskTicket) => (
                <TableRow
                  key={zendeskTicket.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row" align="left">
                    <Link
                      href={zendeskTicket.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {zendeskTicket.zendeskId}
                    </Link>
                  </TableCell>
                  <TableCell align="left">
                    <Chip
                      label={
                        getStatusDisplayInfo(zendeskTicket.status)
                          .translatedStatus
                      }
                      color={
                        getStatusDisplayInfo(zendeskTicket.status).colorStatus
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell align="left">{zendeskTicket.channel}</TableCell>
                  <TableCell align="left">{zendeskTicket.requester}</TableCell>
                  <TableCell align="left">{zendeskTicket.subject}</TableCell>
                  <TableCell align="left">{zendeskTicket.assignee}</TableCell>
                  <TableCell align="left">
                    {moment(zendeskTicket.createdAt).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    {moment(zendeskTicket.updatedAt).format('DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={async () => {
                        await handleUnlinkZendeskTicket(zendeskTicket.id)
                      }}
                      aria-label="unlink"
                    >
                      <DeleteOutlineOutlinedIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: 'background.paper',
          paddingY: 2,
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            color="primary"
            onClick={navigateToSearchView}
            size="large"
          >
            Rattacher un ticket Zendesk
          </Button>
        </Box>
      </Box>
    </>
  )
}
